/*
 * Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {AfterViewInit, Component, EventEmitter, Output, ViewChild} from '@angular/core';
import {Select} from 'primeng/select';

@Component({
    selector: 'app-typeahead-cell-editor',
    template: `
        <p-select #dropdown class="set-width" [style.width.px]="width" [(ngModel)]="value"
                    [options]="options" [editable]="editable" [filter]="true" placeholder="Select Item"
                    (onChange)="onSelectionChange()"
                    [virtualScroll]="true" [virtualScrollItemSize]="38"></p-select>`,
    standalone: false
})
export class TypeaheadCellEditorComponent implements AfterViewInit {
    @ViewChild('dropdown') dropdown?: Select;
    value: any;
    options: string[] = [];
    editable = true;
    width = 200;
    @Output() valueChange = new EventEmitter<any>();

    agInit(params: any): void {
        this.value = params.value;
        this.options = params.colDef.cellEditorParams?.values || [];
        this.width = params.colDef.maxWidth || 200;
        if (params.colDef.width) {
            this.width = params.colDef.width;
        }
        // if on milestone column and not a milestone row then make cell non-editable
        // or if its the yes/no esor report dropdown
        if ((params.colDef.field === 'milestone' && params.data.phase !== 'Milestone')
            || params.colDef.field === 'includeInEsorReport') {
            this.editable = false;
        }

        if (!!params.editable) {
            this.editable = params.editable;
        }
    }

    getValue(): any {
        return this.value;
    }

    // Workaround since prime ng does not support filtering for simple string arrays
    ngAfterViewInit(): void {
        if (this.dropdown) {
            (this.dropdown.filterBy as any) = {
                split: (_: any) => [(item: any) => item],
            };
        }
    }

    onSelectionChange(): void {
        const value = this.getValue();
        this.valueChange.emit(value);
    }

}

